import "./Search.css";
import search from "../../../../../assets/search.png";
import filter from "../../../../../assets/filter.png";
const Search = () => {
 return (
  <>
   <div className="payouts-search desktop">
    <p className="filter-text">FILTER BY</p>

    <div className="search-inputs">
     <div className="input-container">
      <label htmlFor="product-code">Transaction ID</label>
      <input id="product-code" type="text" placeholder="Enter ID" />
     </div>
     <div className="input-container">
      <label htmlFor="product-code">Product name</label>
      <input id="product-code" type="text" placeholder="Enter name" />
     </div>

     <div className="input-container">
      <label htmlFor="product-code">Amount</label>
      <div className="custom-input">
       <select id="product-code">
        <option defaultValue>N</option>
        <option>$</option>
        <option>#</option>
       </select>
       <input id="product-code" type="text" placeholder="Enter amount" />
      </div>
     </div>

     <div className="input-container">
      <label htmlFor="product-code">Status</label>

      <select id="product-code">
       <option defaultValue>All</option>
      </select>
     </div>

     <div className="input-container">
      <label htmlFor="product-code">Date</label>
      <div className="custom-input">
       <input id="product-code" type="date" placeholder="Enter amount" />
      </div>
     </div>
    </div>
   </div>
   <div className="payouts-search mobile">
    <div className="img">
     <img src={search} alt="search" />
    </div>
    <div className="input-container">
     <input type="text" placeholder="Search" />
    </div>
    <div className="filter-shapBtn">
     <p>Filter</p>
     <img src={filter} alt="search" />
    </div>
   </div>
  </>
 );
};

export default Search;
